import loadMoreInit from './handlers/loadMoreArticles';

require('features/routing');
require('features/articleSearchBox');
require('features/articleCardCarousel');

require('features/googleAnalytics4');
require('./components/eventTracking/googleAnalytics4EventsHandler');

require('features/segment');
require('./components/eventTracking/segmentEventsHandler');

// ugly injection for those components, after rebrand this will be
// removed once the listing for you section is moved to its own page
require('../../blog/components/listingsForYouSection');
require('../../blog/handlers/hyperlinkCardHandler');
require('../../newsAndTrends/handlers/hamburgerMenuHandler');

loadMoreInit();
